import { ComponentStyleConfig } from '@chakra-ui/theme'

export const Alert: ComponentStyleConfig = {
  parts: ['container'],
  baseStyle: {
    borderRadius: 'md',
  },
  variants: {
    subtle: {
      borderRadius: 'md',
    },
  },
}
